import '../../boot'
import './index.scss'
import { createApp } from 'vue/dist/vue.esm-bundler'
import AppLayoutMixin from '../../app-layout-mixin'
import { NButton, NFormItem, NInputNumber, NRadioGroup, NRadioButton, NForm, NProgress, NTabs, NTabPane, NCard, NTable, NThead, NTbody, NTh, NTr, NTd } from 'naive-ui'
import EmbedCode from "@/components/embed";


createApp({
    components: { NButton, NFormItem, NInputNumber, NRadioGroup, NRadioButton, NForm, NProgress, NTabs, NTabPane, NCard, NTable, NThead, NTbody, NTh, NTr, NTd, EmbedCode },
    mixins: [ AppLayoutMixin ],
    data() {
        return {
            // age: null,
            // gender: 'male',
            tab: 'metric',
            metric: {
                height: null,
                weight: null,
            },
            us: {
                height: null,
                weight: null,
            }
        }
    },
    computed: {
        bmiMetric() {
            if (!this.metric.weight || !this.metric.height) {
                return null;
            }
            return (this.metric.weight / Math.pow( (this.metric.height/100), 2 )).toFixed(1);
        },
        bmiUs() {
            if (!this.us.weight || !this.us.height) {
                return null;
            }
            return (703*(this.us.weight / Math.pow( this.us.height, 2 ))).toFixed(1);
        },
        bmi() {
            return this.tab === 'metric' ? this.bmiMetric : this.bmiUs;
        },
        bmiDesc() {
            if (!this.bmi) {
                return '';
            }
            if (this.bmi < 16) {
                return 'Severe Thinness';
            }
            if (this.bmi < 16) {
                return 'Moderate Thinness';
            }
            if (this.bmi < 18.5) {
                return 'Mild Thinness';
            }
            if (this.bmi < 25) {
                return 'Normal';
            }
            if (this.bmi < 30) {
                return 'Overweight';
            }
            if (this.bmi < 35) {
                return 'Obese Class I';
            }
            if (this.bmi < 40) {
                return 'Obese Class II';
            }
            return 'Obese Class III';
        },
        bmiStatus() {
            if (!this.bmi) {
                return 'default';
            }
            if (this.bmi < 16) {
                return 'error';
            }
            if (this.bmi < 18.5) {
                return 'warning';
            }
            if (this.bmi < 25) {
                return 'success';
            }
            if (this.bmi < 30) {
                return 'warning';
            }
            return 'error';
        },
        bmiPercentage() {
            return this.bmi/40*100;
        }
    }
}).mount('#app')
